import { IconButton } from "@mui/material";
import { useStore } from "../../store/store";
import { Shield as ShieldIcon, GppGood as GppGoodIcon } from "@mui/icons-material";

export const HideUIFromClientButton = () => {
  const { hideUIFromClient } = useStore();
  const { isHiddenFromClient } = hideUIFromClient;

  return (
    <IconButton
      onClick={hideUIFromClient.toggleIsHiddenFromClient}
      color="inherit"
      aria-label="toggle componets visibility"
    >
      {isHiddenFromClient ? <GppGoodIcon fontSize="medium" /> : <ShieldIcon fontSize="medium" />}
    </IconButton>
  );
};
